import React, { ReactChild, useCallback } from "react";
import { useDevicePermissionsStore } from "../storez/DevicePermissionsStore";
import { Permission } from "../types/Authorization";

const AuthorizationWrapper: React.FC<{
  children: ReactChild | ReactChild[] | unknown;
  allowedRoles: Readonly<Permission[]> | string[];
}> = ({ children, allowedRoles }) => {
  const [supportAdmin, permissions, permissionsLoaded] = useDevicePermissionsStore(
    useCallback((state) => [state.supportAdmin, state.permissions, state.loaded] as const, [])
  );

  if (!permissionsLoaded || (!permissions.some((p) => allowedRoles.indexOf(p) !== -1) && !supportAdmin)) {
    return <></>;
  }

  return <>{children}</>;
};

export default AuthorizationWrapper;
